export default "__VITE_ASSET__BR_hQ_dT__"